export const COUNTRIES = [
  { code: "AD", label: "Andorra", phone: "376", iso: "AND" },
  { code: "AE", label: "United Arab Emirates", phone: "971", iso: "ARE" },
  { code: "AF", label: "Afghanistan", phone: "93", iso: "AFG" },
  { code: "AG", label: "Antigua and Barbuda", phone: "1-268", iso: "ATG" },
  { code: "AI", label: "Anguilla", phone: "1-264", iso: "AIA" },
  { code: "AL", label: "Albania", phone: "355", iso: "ALB" },
  { code: "AM", label: "Armenia", phone: "374", iso: "ARM" },
  { code: "AO", label: "Angola", phone: "244", iso: "AGO" },
  { code: "AQ", label: "Antarctica", phone: "672", iso: "ATA" },
  { code: "AR", label: "Argentina", phone: "54", iso: "ARG" },
  { code: "AS", label: "American Samoa", phone: "1-684", iso: "ASM" },
  { code: "AT", label: "Austria", phone: "43", iso: "AUT" },
  { code: "AU", label: "Australia", phone: "61", iso: "AUS" },
  { code: "AW", label: "Aruba", phone: "297", iso: "ABW" },
  { code: "AX", label: "Alland Islands", phone: "358", iso: "ALA" },
  { code: "AZ", label: "Azerbaijan", phone: "994", iso: "AZE" },
  { code: "BA", label: "Bosnia and Herzegovina", phone: "387", iso: "BIH" },
  { code: "BB", label: "Barbados", phone: "1-246", iso: "BRB" },
  { code: "BD", label: "Bangladesh", phone: "880", iso: "BGD" },
  { code: "BE", label: "Belgium", phone: "32", iso: "BEL" },
  { code: "BF", label: "Burkina Faso", phone: "226", iso: "BFA" },
  { code: "BG", label: "Bulgaria", phone: "359", iso: "BGR" },
  { code: "BH", label: "Bahrain", phone: "973", iso: "BHR" },
  { code: "BI", label: "Burundi", phone: "257", iso: "BDI" },
  { code: "BJ", label: "Benin", phone: "229", iso: "BEN" },
  { code: "BL", label: "Saint Barthelemy", phone: "590", iso: "BLM" },
  { code: "BM", label: "Bermuda", phone: "1-441", iso: "BMU" },
  { code: "BN", label: "Brunei Darussalam", phone: "673", iso: "BRN" },
  { code: "BO", label: "Bolivia", phone: "591", iso: "BOL" },
  { code: "BR", label: "Brazil", phone: "55", iso: "BRA" },
  { code: "BS", label: "Bahamas", phone: "1-242", iso: "BHS" },
  { code: "BT", label: "Bhutan", phone: "975", iso: "BTN" },
  { code: "BV", label: "Bouvet Island", phone: "47", iso: "BVT" },
  { code: "BW", label: "Botswana", phone: "267", iso: "BWA" },
  { code: "BY", label: "Belarus", phone: "375", iso: "BLR" },
  { code: "BZ", label: "Belize", phone: "501", iso: "BLZ" },
  { code: "CA", label: "Canada", phone: "1", iso: "CAN" },
  { code: "CC", label: "Cocos (Keeling) Islands", phone: "61", iso: "CCK" },
  {
    code: "CD",
    label: "Congo, Democratic Republic of the",
    phone: "243",
    iso: "COD",
  },
  { code: "CF", label: "Central African Republic", phone: "236", iso: "CAF" },
  { code: "CG", label: "Congo, Republic of the", phone: "242", iso: "COG" },
  { code: "CH", label: "Switzerland", phone: "41", iso: "CHE" },
  { code: "CI", label: "Cote d'Ivoire", phone: "225", iso: "CIV" },
  { code: "CK", label: "Cook Islands", phone: "682", iso: "COK" },
  { code: "CL", label: "Chile", phone: "56", iso: "CHL" },
  { code: "CM", label: "Cameroon", phone: "237", iso: "CMR" },
  { code: "CN", label: "China", phone: "86", iso: "CHN" },
  { code: "CO", label: "Colombia", phone: "57", iso: "COL" },
  { code: "CR", label: "Costa Rica", phone: "506", iso: "CRI" },
  { code: "CU", label: "Cuba", phone: "53", iso: "CUB" },
  { code: "CV", label: "Cape Verde", phone: "238", iso: "CPV" },
  { code: "CW", label: "Curacao", phone: "599", iso: "CUW" },
  { code: "CX", label: "Christmas Island", phone: "61", iso: "CXR" },
  { code: "CY", label: "Cyprus", phone: "357", iso: "CYP" },
  { code: "CZ", label: "Czech Republic", phone: "420", iso: "CZE" },
  { code: "DE", label: "Germany", phone: "49", iso: "DEU" },
  { code: "DJ", label: "Djibouti", phone: "253", iso: "DJI" },
  { code: "DK", label: "Denmark", phone: "45", iso: "DNK" },
  { code: "DM", label: "Dominica", phone: "1-767", iso: "DMA" },
  { code: "DO", label: "Dominican Republic", phone: "1-809", iso: "DOM" },
  { code: "DZ", label: "Algeria", phone: "213", iso: "DZA" },
  { code: "EC", label: "Ecuador", phone: "593", iso: "ECU" },
  { code: "EE", label: "Estonia", phone: "372", iso: "EST" },
  { code: "EG", label: "Egypt", phone: "20", iso: "EGY" },
  { code: "EH", label: "Western Sahara", phone: "212", iso: "ESH" },
  { code: "ER", label: "Eritrea", phone: "291", iso: "ERI" },
  { code: "ES", label: "Spain", phone: "34", iso: "ESP" },
  { code: "ET", label: "Ethiopia", phone: "251", iso: "ETH" },
  { code: "FI", label: "Finland", phone: "358", iso: "FIN" },
  { code: "FJ", label: "Fiji", phone: "679", iso: "FJI" },
  {
    code: "FK",
    label: "Falkland Islands (Malvinas)",
    phone: "500",
    iso: "FLK",
  },
  {
    code: "FM",
    label: "Micronesia, Federated States of",
    phone: "691",
    iso: "FSM",
  },
  { code: "FO", label: "Faroe Islands", phone: "298", iso: "FRO" },
  { code: "FR", label: "France", phone: "33", iso: "FRA" },
  { code: "GA", label: "Gabon", phone: "241", iso: "GAB" },
  { code: "GB", label: "United Kingdom", phone: "44", iso: "GBR" },
  { code: "GD", label: "Grenada", phone: "1-473", iso: "GRD" },
  { code: "GE", label: "Georgia", phone: "995", iso: "GEO" },
  { code: "GF", label: "French Guiana", phone: "594", iso: "GUF" },
  { code: "GG", label: "Guernsey", phone: "44", iso: "GGY" },
  { code: "GH", label: "Ghana", phone: "233", iso: "GHA" },
  { code: "GI", label: "Gibraltar", phone: "350", iso: "GIB" },
  { code: "GL", label: "Greenland", phone: "299", iso: "GRL" },
  { code: "GM", label: "Gambia", phone: "220", iso: "GMB" },
  { code: "GN", label: "Guinea", phone: "224", iso: "GIN" },
  { code: "GP", label: "Guadeloupe", phone: "590", iso: "GLP" },
  { code: "GQ", label: "Equatorial Guinea", phone: "240", iso: "GNQ" },
  { code: "GR", label: "Greece", phone: "30", iso: "GRC" },
  {
    code: "GS",
    label: "South Georgia and the South Sandwich Islands",
    phone: "500",
    iso: "SGS",
  },
  { code: "GT", label: "Guatemala", phone: "502", iso: "GTM" },
  { code: "GU", label: "Guam", phone: "1-671", iso: "GUM" },
  { code: "GW", label: "Guinea-Bissau", phone: "245", iso: "GNB" },
  { code: "GY", label: "Guyana", phone: "592", iso: "GUY" },
  { code: "HK", label: "Hong Kong", phone: "852", iso: "HKG" },
  {
    code: "HM",
    label: "Heard Island and McDonald Islands",
    phone: "672",
    iso: "HMD",
  },
  { code: "HN", label: "Honduras", phone: "504", iso: "HND" },
  { code: "HR", label: "Croatia", phone: "385", iso: "HRV" },
  { code: "HT", label: "Haiti", phone: "509", iso: "HTI" },
  { code: "HU", label: "Hungary", phone: "36", iso: "HUN" },
  { code: "ID", label: "Indonesia", phone: "62", iso: "IDN" },
  { code: "IE", label: "Ireland", phone: "353", iso: "IRL" },
  { code: "IL", label: "Israel", phone: "972", iso: "ISR" },
  { code: "IM", label: "Isle of Man", phone: "44", iso: "IMN" },
  { code: "IN", label: "India", phone: "91", iso: "IND" },
  {
    code: "IO",
    label: "British Indian Ocean Territory",
    phone: "246",
    iso: "IOT",
  },
  { code: "IQ", label: "Iraq", phone: "964", iso: "IRQ" },
  { code: "IR", label: "Iran, Islamic Republic of", phone: "98", iso: "IRN" },
  { code: "IS", label: "Iceland", phone: "354", iso: "ISL" },
  { code: "IT", label: "Italy", phone: "39", iso: "ITA" },
  { code: "JE", label: "Jersey", phone: "44", iso: "JEY" },
  { code: "JM", label: "Jamaica", phone: "1-876", iso: "JAM" },
  { code: "JO", label: "Jordan", phone: "962", iso: "JOR" },
  { code: "JP", label: "Japan", phone: "81", iso: "JPN" },
  { code: "KE", label: "Kenya", phone: "254", iso: "KEN" },
  { code: "KG", label: "Kyrgyzstan", phone: "996", iso: "KGZ" },
  { code: "KH", label: "Cambodia", phone: "855", iso: "KHM" },
  { code: "KI", label: "Kiribati", phone: "686", iso: "KIR" },
  { code: "KM", label: "Comoros", phone: "269", iso: "COM" },
  { code: "KN", label: "Saint Kitts and Nevis", phone: "1-869", iso: "KNA" },
  {
    code: "KP",
    label: "Korea, Democratic People's Republic of",
    phone: "850",
    iso: "PRK",
  },
  { code: "KR", label: "Korea, Republic of", phone: "82", iso: "KOR" },
  { code: "KW", label: "Kuwait", phone: "965", iso: "KWT" },
  { code: "KY", label: "Cayman Islands", phone: "1-345", iso: "CYM" },
  { code: "KZ", label: "Kazakhstan", phone: "7", iso: "KAZ" },
  {
    code: "LA",
    label: "Lao People's Democratic Republic",
    phone: "856",
    iso: "LAO",
  },
  { code: "LB", label: "Lebanon", phone: "961", iso: "LBN" },
  { code: "LC", label: "Saint Lucia", phone: "1-758", iso: "LCA" },
  { code: "LI", label: "Liechtenstein", phone: "423", iso: "LIE" },
  { code: "LK", label: "Sri Lanka", phone: "94", iso: "LKA" },
  { code: "LR", label: "Liberia", phone: "231", iso: "LBR" },
  { code: "LS", label: "Lesotho", phone: "266", iso: "LSO" },
  { code: "LT", label: "Lithuania", phone: "370", iso: "LTU" },
  { code: "LU", label: "Luxembourg", phone: "352", iso: "LUX" },
  { code: "LV", label: "Latvia", phone: "371", iso: "LVA" },
  { code: "LY", label: "Libya", phone: "218", iso: "LBY" },
  { code: "MA", label: "Morocco", phone: "212", iso: "MAR" },
  { code: "MC", label: "Monaco", phone: "377", iso: "MCO" },
  { code: "MD", label: "Moldova, Republic of", phone: "373", iso: "MDA" },
  { code: "ME", label: "Montenegro", phone: "382", iso: "MNE" },
  { code: "MF", label: "Saint Martin (French part)", phone: "590", iso: "MAF" },
  { code: "MG", label: "Madagascar", phone: "261", iso: "MDG" },
  { code: "MH", label: "Marshall Islands", phone: "692", iso: "MHL" },
  {
    code: "MK",
    label: "Macedonia, the Former Yugoslav Republic of",
    phone: "389",
    iso: "MKD",
  },
  { code: "ML", label: "Mali", phone: "223", iso: "MLI" },
  { code: "MM", label: "Myanmar", phone: "95", iso: "MMR" },
  { code: "MN", label: "Mongolia", phone: "976", iso: "MNG" },
  { code: "MO", label: "Macao", phone: "853", iso: "MAC" },
  { code: "MP", label: "Northern Mariana Islands", phone: "1-670", iso: "MNP" },
  { code: "MQ", label: "Martinique", phone: "596", iso: "MTQ" },
  { code: "MR", label: "Mauritania", phone: "222", iso: "MRT" },
  { code: "MS", label: "Montserrat", phone: "1-664", iso: "MSR" },
  { code: "MT", label: "Malta", phone: "356", iso: "MLT" },
  { code: "MU", label: "Mauritius", phone: "230", iso: "MUS" },
  { code: "MV", label: "Maldives", phone: "960", iso: "MDV" },
  { code: "MW", label: "Malawi", phone: "265", iso: "MWI" },
  { code: "MX", label: "Mexico", phone: "52", iso: "MEX" },
  { code: "MY", label: "Malaysia", phone: "60", iso: "MYS" },
  { code: "MZ", label: "Mozambique", phone: "258", iso: "MOZ" },
  { code: "NA", label: "Namibia", phone: "264", iso: "NAM" },
  { code: "NC", label: "New Caledonia", phone: "687", iso: "NCL" },
  { code: "NE", label: "Niger", phone: "227", iso: "NER" },
  { code: "NF", label: "Norfolk Island", phone: "672", iso: "NFK" },
  { code: "NG", label: "Nigeria", phone: "234", iso: "NGA" },
  { code: "NI", label: "Nicaragua", phone: "505", iso: "NIC" },
  { code: "NL", label: "Netherlands", phone: "31", iso: "NLD" },
  { code: "NO", label: "Norway", phone: "47", iso: "NOR" },
  { code: "NP", label: "Nepal", phone: "977", iso: "NPL" },
  { code: "NR", label: "Nauru", phone: "674", iso: "NRU" },
  { code: "NU", label: "Niue", phone: "683", iso: "NIU" },
  { code: "NZ", label: "New Zealand", phone: "64", iso: "NZL" },
  { code: "OM", label: "Oman", phone: "968", iso: "OMN" },
  { code: "PA", label: "Panama", phone: "507", iso: "PAN" },
  { code: "PE", label: "Peru", phone: "51", iso: "PER" },
  { code: "PF", label: "French Polynesia", phone: "689", iso: "PYF" },
  { code: "PG", label: "Papua New Guinea", phone: "675", iso: "PNG" },
  { code: "PH", label: "Philippines", phone: "63", iso: "PHL" },
  { code: "PK", label: "Pakistan", phone: "92", iso: "PAK" },
  { code: "PL", label: "Poland", phone: "48", iso: "POL" },
  { code: "PM", label: "Saint Pierre and Miquelon", phone: "508", iso: "SPM" },
  { code: "PN", label: "Pitcairn", phone: "870", iso: "PCN" },
  { code: "PR", label: "Puerto Rico", phone: "1", iso: "PRI" },
  { code: "PS", label: "Palestine, State of", phone: "970", iso: "PSE" },
  { code: "PT", label: "Portugal", phone: "351", iso: "PRT" },
  { code: "PW", label: "Palau", phone: "680", iso: "PLW" },
  { code: "PY", label: "Paraguay", phone: "595", iso: "PRY" },
  { code: "QA", label: "Qatar", phone: "974", iso: "QAT" },
  { code: "RE", label: "Reunion", phone: "262", iso: "REU" },
  { code: "RO", label: "Romania", phone: "40", iso: "ROU" },
  { code: "RS", label: "Serbia", phone: "381", iso: "SRB" },
  { code: "RU", label: "Russian Federation", phone: "7", iso: "RUS" },
  { code: "RW", label: "Rwanda", phone: "250", iso: "RWA" },
  { code: "SA", label: "Saudi Arabia", phone: "966", iso: "SAU" },
  { code: "SB", label: "Solomon Islands", phone: "677", iso: "SLB" },
  { code: "SC", label: "Seychelles", phone: "248", iso: "SYC" },
  { code: "SD", label: "Sudan", phone: "249", iso: "SDN" },
  { code: "SE", label: "Sweden", phone: "46", iso: "SWE" },
  { code: "SG", label: "Singapore", phone: "65", iso: "SGP" },
  { code: "SH", label: "Saint Helena", phone: "290", iso: "SHN" },
  { code: "SI", label: "Slovenia", phone: "386", iso: "SVN" },
  { code: "SJ", label: "Svalbard and Jan Mayen", phone: "47", iso: "SJM" },
  { code: "SK", label: "Slovakia", phone: "421", iso: "SVK" },
  { code: "SL", label: "Sierra Leone", phone: "232", iso: "SLE" },
  { code: "SM", label: "San Marino", phone: "378", iso: "SMR" },
  { code: "SN", label: "Senegal", phone: "221", iso: "SEN" },
  { code: "SO", label: "Somalia", phone: "252", iso: "SOM" },
  { code: "SR", label: "Suriname", phone: "597", iso: "SUR" },
  { code: "SS", label: "South Sudan", phone: "211", iso: "SSD" },
  { code: "ST", label: "Sao Tome and Principe", phone: "239", iso: "STP" },
  { code: "SV", label: "El Salvador", phone: "503", iso: "SLV" },
  {
    code: "SX",
    label: "Sint Maarten (Dutch part)",
    phone: "1-721",
    iso: "SXM",
  },
  { code: "SY", label: "Syrian Arab Republic", phone: "963", iso: "SYR" },
  { code: "SZ", label: "Swaziland", phone: "268", iso: "SWZ" },
  { code: "TC", label: "Turks and Caicos Islands", phone: "1-649", iso: "TCA" },
  { code: "TD", label: "Chad", phone: "235", iso: "TCD" },
  {
    code: "TF",
    label: "French Southern Territories",
    phone: "262",
    iso: "ATF",
  },
  { code: "TG", label: "Togo", phone: "228", iso: "TGO" },
  { code: "TH", label: "Thailand", phone: "66", iso: "THA" },
  { code: "TJ", label: "Tajikistan", phone: "992", iso: "TJK" },
  { code: "TK", label: "Tokelau", phone: "690", iso: "TKL" },
  { code: "TL", label: "Timor-Leste", phone: "670", iso: "TLS" },
  { code: "TM", label: "Turkmenistan", phone: "993", iso: "TKM" },
  { code: "TN", label: "Tunisia", phone: "216", iso: "TUN" },
  { code: "TO", label: "Tonga", phone: "676", iso: "TON" },
  { code: "TR", label: "Turkey", phone: "90", iso: "TUR" },
  { code: "TT", label: "Trinidad and Tobago", phone: "1-868", iso: "TTO" },
  { code: "TV", label: "Tuvalu", phone: "688", iso: "TUV" },
  { code: "TW", label: "Taiwan, Province of China", phone: "886", iso: "TWN" },
  {
    code: "TZ",
    label: "United Republic of Tanzania",
    phone: "255",
    iso: "TZA",
  },
  { code: "UA", label: "Ukraine", phone: "380", iso: "UKR" },
  { code: "UG", label: "Uganda", phone: "256", iso: "UGA" },
  { code: "US", label: "United States", phone: "1", iso: "USA" },
  { code: "UY", label: "Uruguay", phone: "598", iso: "URY" },
  { code: "UZ", label: "Uzbekistan", phone: "998", iso: "UZB" },
  {
    code: "VA",
    label: "Holy See (Vatican City State)",
    phone: "379",
    iso: "VAT",
  },
  {
    code: "VC",
    label: "Saint Vincent and the Grenadines",
    phone: "1-784",
    iso: "VCT",
  },
  { code: "VE", label: "Venezuela", phone: "58", iso: "VEN" },
  { code: "VG", label: "British Virgin Islands", phone: "1-284", iso: "VGB" },
  { code: "VI", label: "US Virgin Islands", phone: "1-340", iso: "VIR" },
  { code: "VN", label: "Vietnam", phone: "84", iso: "VNM" },
  { code: "VU", label: "Vanuatu", phone: "678", iso: "VUT" },
  { code: "WF", label: "Wallis and Futuna", phone: "681", iso: "WLF" },
  { code: "WS", label: "Samoa", phone: "685", iso: "WSM" },
  { code: "XK", label: "Kosovo", phone: "383", iso: "XKX" },
  { code: "YE", label: "Yemen", phone: "967", iso: "YEM" },
  { code: "YT", label: "Mayotte", phone: "262", iso: "MYT" },
  { code: "ZA", label: "South Africa", phone: "27", iso: "ZAF" },
  { code: "ZM", label: "Zambia", phone: "260", iso: "ZMB" },
  { code: "ZW", label: "Zimbabwe", phone: "263", iso: "ZWE" },
];
